import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

@Injectable()
export class NewApiHttpService {
	constructor(private http: HttpClient, private auth: AuthService) {}

	private handleNewAPIError(error: any) {
		if (error.error instanceof ErrorEvent) {
			console.error('An error occurred:', error.error.message);
		} else if (typeof error === 'string') {
			console.error('An error occurred:' + error);
			const errorToDisplay = error && error !== 'Unknown Error' ? error : 'Something bad happened; please try again later.';
			return throwError(errorToDisplay);
		} else if (typeof error === 'object' && error !== null) {
			console.error('An error occurred:', error);
			return throwError(error[Object.keys(error)[0]]);
		}
		// return an ErrorObservable with a user-facing error message
		return throwError('Something bad happened; please try again later.');
	}

	newApiRequestGet(route: string, query: object = {}, originalUser: boolean = false): Observable<any> {
		let httpParams = new HttpParams();
		Object.keys(query).forEach(function (key) {
			httpParams = httpParams.append(key, query[key]);
		});
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				Authorization: this.auth.getNewAPILoginToken(originalUser)
			}),
			params: httpParams
		};
		return this.http.get<any>(environment.newApiURL + '/' + route, httpOptions).pipe(retry(3), catchError(this.handleNewAPIError));
	}

	newApiRequestPut(route: string, data: any): Observable<NewApiResponse> {
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				authorization: this.auth.getNewAPILoginToken()
			})
		};

		return this.http
			.put<any>(environment.newApiURL + '/' + route, data, httpOptions)
			.pipe(retry(3), catchError(this.handleNewAPIError));
	}

	newApiRequestUpload(route: string, data: any): Observable<NewApiResponse> {
		const httpOptions = {
			headers: new HttpHeaders({ authorization: this.auth.getNewAPILoginToken() })
		};
		return this.http.post<any>(environment.newApiURL + '/' + route, data, httpOptions);
	}

	newApiRequestDelete(route: string, data: any): Observable<NewApiResponse> {
		let httpParams = new HttpParams();
		Object.keys(data).forEach(function (key) {
			httpParams = httpParams.append(key, data[key]);
		});
		const httpOptions = {
			headers: new HttpHeaders({ authorization: this.auth.getNewAPILoginToken() }),
			params: httpParams
		};
		return this.http.delete<any>(environment.newApiURL + '/' + route, httpOptions);
	}

	newApiRequestPost(route: string, data: any, retryNumber: number = 3): Observable<NewApiResponse> {
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				authorization: this.auth.getNewAPILoginToken()
			})
		};
		return this.http
			.post<any>(environment.newApiURL + '/' + route, data, httpOptions)
			.pipe(retry(retryNumber), catchError(this.handleNewAPIError));
	}
}

export interface NewApiResponse {
	status: boolean;
	data?: any;
	message?: any;
}
